export enum ProductFamilyKind {
  Sellable = "SELLABLE",
  NonSellable = "NON_SELLABLE",
}
